var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06396 0.180861L0.17655 5.17578C-0.0591658 5.41668 -0.0587989 5.80688 0.177369 6.04731L0.748502 6.62881C0.984268 6.86886 1.36601 6.86896 1.60188 6.62904L5.4935 2.67046L9.39254 6.62171C9.62886 6.86119 10.0106 6.86037 10.2459 6.61988L10.8159 6.03731C11.0517 5.79641 11.0513 5.40621 10.8151 5.16578L5.91834 0.180083C5.6822 -0.060373 5.29967 -0.0600129 5.06396 0.180861Z",
    fill: "#103575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.215381271508b330d0ee6a116447ec08.svg";
export { ForwardRef as ReactComponent };